<template>
  <div>
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/ApprovalIndex"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div style="text-align: left; margin-left: 5%">
      <label style="color: #606266; font-size: 14px">Customer</label>
      <el-select
        v-model="customer"
        clearable
        placeholder="Please Choose"
        style="margin-left: 10px"
      >
        <el-option
          v-for="item in customers"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <label style="margin-left: 20px; color: #606266; font-size: 14px"
        >Type</label
      >
      <el-select
        v-model="type"
        clearable
        placeholder="Please Choose"
        style="margin-left: 10px"
      >
        <el-option
          v-for="item in types"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-input
        v-model="search_input"
        placeholder="Search by Code or Name"
        class="input-search"
      ></el-input>
      <el-button
        class="button-search"
        style="margin-left: 10px"
        @click="BindData(1)"
        >Search</el-button
      >
      <el-button class="button-search" @click="Export">Export</el-button>
    </div>
    <br />
    <div class="content_title">
      <div class="div-pagination">
        <el-pagination
          background
          @current-change="pagingChange"
          :current-page.sync="currentPage"
          :page-size="100"
          layout="total, prev, pager, next, jumper"
          :total="total"
          ref="multipleTable"
        ></el-pagination>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          @current-change="handleCurrentChange"
          :data="tableData"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          border
        >
          <el-table-column label="Project Code" min-width="160px">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="padding: 0px; text-decoration: underline"
                size="small"
                @click="Closure(scope.row.projectID)"
                v-if="scope.row.type == 'Closure'"
                >{{ scope.row.projectcode }}</el-button
              >
              <el-button
                type="text"
                style="padding: 0px; text-decoration: underline"
                size="small"
                @click="Detail(scope.row.projectID)"
                v-if="!(scope.row.type == 'Closure')"
                >{{ scope.row.projectcode }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="nameEN"
            label="POS Name"
            min-width="220px"
          ></el-table-column>
          <el-table-column
            prop="nameCN"
            label="POS Name(CN)"
            min-width="220px"
          ></el-table-column>
          <el-table-column
            prop="customername"
            label="Customer"
          ></el-table-column>
          <el-table-column
            prop="status_nameEN"
            label="Status"
          ></el-table-column>
          <el-table-column prop="appDate" label="Apply Date"></el-table-column>
          <el-table-column prop="type" label="Type"></el-table-column>
        </el-table>
      </div>
      <div style="height: 20px"></div>
    </div>
  </div>
</template>

<script>
import Download from "@/common/js/Download.js";
import {encryption} from '@/utils/secret.js'
export default {
  data() {
    return {
      total: 0,
      loading: true,
      currentPage: 1,
      tableData: [],
      search_input: "",
      multipleSelection: [],
      customer: "",
      customers: [],
      type: "",
      types: [],
    };
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    BindData(pageIndex) {
      this.currentPage = pageIndex;
      this.loading = true;
      this.$api
        .get(
          "/List/GetEndPendingProjectInfo/",
          {
            pageIndex: pageIndex,
            search: this.search_input,
            customer: this.customer,
            type: this.type,
          },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status == true) {
            this.tableData = res.data.content.list;
            this.total = res.data.content.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    Detail(projectID) {
       this.$router.push({
        path: "/Project",
        query: { ID: encryption(projectID), isapprove: encryption('false') },
      });
      //  this.$router.push({
      //   name: "Project",
      //   params: { ID: projectID, isapprove: false },
      // });
    },
    Closure(projectID) {
      this.$router.push({
        name: "Closure",
        params: { ID: projectID, isapprove: false },
      });
    },
    GetCustomer() {
      this.$api
        .get("/List/GetCustomer/", {}, (res) => {})
        .then((res) => {
          if (res.data.status == true) {
            this.customers = res.data.content;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
        });
    },
    GetTypes() {
      this.$api
        .get("/List/GetTypes/", {}, (res) => {})
        .then((res) => {
          if (res.data.status == true) {
            this.types = res.data.content;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
        });
    },
    Export() {
      this.$api
        .post(
          "/List/Export",
          {
            search: this.search_input,
            customer: this.customer,
            type: this.type,
          },
          "arraybuffer"
        )
        .then((res) => {
          let filename = "Approved Projects.xlsx";
          Download(res.data, filename);
        })
        .catch((e) => {
          this.$message({ message: "Fail!", type: "warring" });
        });
    },
  },
  mounted() {
    this.GetCustomer();
    this.GetTypes();
    this.BindData(1);
  },
};
</script>
<style scoped>
.el-table ::v-deep .cell,
.el-table ::v-deep th {
  padding-left: 10px;
}
.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
}
.el-button--text {
  color: #606266;
}
.input-search {
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 10px;
  width: 300px;
  text-align: left;
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
}
.div-pagination {
  text-align: right;
  margin-bottom: 10px;
}
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
</style>
<style>
.el-table .cell,
.el-table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px !important;
}
.el-select-dropdown__wrap {
  max-height: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/EndList.vue